import { render } from "./medical-records-modal.vue?vue&type=template&id=cccd944c"
import script from "./medical-records-modal.vue?vue&type=script&lang=js"
export * from "./medical-records-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__